import { PmsDirectoryWatcher } from 'app/pms/directoryWatcher';
import handleFileInput from 'app/pms/handleFileInput';
import { AggregatedParser } from 'app/pms/parser/AggregatedParser';
import PmsParser from 'app/pms/parser/PmsParser';
import { makeSelectWatchedDirectory, selectPMSReducer } from 'app/redux/pms/selector';
import { PmsFileHandler } from 'app/pms/types';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useSelector, useStore } from 'react-redux';

export const PMSParserContext = React.createContext<PmsDirectoryWatcher>(undefined);

type PMSParserProviderProps = {
  externalParser: PmsParser;
  fileHandler: PmsFileHandler;
};

const PMSParserProvider = ({
  children,
  externalParser,
  fileHandler,
}: PropsWithChildren<PMSParserProviderProps>) => {
  const store = useStore();
  const pmsConfiguration = useSelector(selectPMSReducer);
  const pmsWatchedDirectory = useSelector(makeSelectWatchedDirectory());
  const [parser] = useState(() => externalParser ?? new AggregatedParser());
  const [pmsDirectoryWatcher] = useState(
    () => new PmsDirectoryWatcher(fileHandler ?? handleFileInput, parser.parse)
  );

  useEffect(() => {
    // console.log('pmsWatchedDirectory', pmsWatchedDirectory);
    pmsDirectoryWatcher.onDirectoryChange({ store, state: pmsWatchedDirectory });
  }, [pmsWatchedDirectory]);

  useEffect(() => {
    // console.log('pmsConfiguration', pmsConfiguration);
    parser.updateConfiguration(pmsConfiguration);
  }, [pmsConfiguration]);

  return (
    <PMSParserContext.Provider value={pmsDirectoryWatcher}>{children}</PMSParserContext.Provider>
  );
};

export default PMSParserProvider;
